import React, { Component } from 'react';
import { Button, Dimmer, Dropdown, Grid, Header, Input, Loader, Modal, Segment, Tab } from 'semantic-ui-react';
import axios from 'axios';
import ReactJson from 'react-json-view';
import SyntaxHighlighter from 'react-syntax-highlighter/prism';
import { okaidia } from 'react-syntax-highlighter/styles/prism';
import { createVideo } from "./data";
import { getUserID, nullCheck } from "./helpers";
import config from './config';
import './Sandbox.scss';

const fireCleverTapEvent = (name, attributes) => {
	// console.log(`Clevertap event for - ${name}`, `Attributes - ${JSON.stringify(attributes)}`);
	if (window.clevertap) {
		window.clevertap.event.push(name, attributes || {});
	}
};

class CreateVideoInput extends Component {
	constructor(props) {
		super(props);
		this.onDataEdit = this.onDataEdit.bind(this);
		this.onDataAdd = this.onDataAdd.bind(this);
		this.onDataDelete = this.onDataDelete.bind(this);
	}

	onDataEdit(edit) {
		this.props.onDataEdit(edit.updated_src);
	}

	onDataAdd(add) {
		this.props.onDataAdd(add.updated_src);
	}

	onDataDelete(deleteData) {
		this.props.onDataDelete(deleteData.updated_src);
	}

	render() {
		// const
		return <ReactJson
			src={this.props.data}
			name={false}
			enableClipboard={false}
			onEdit={this.onDataEdit}
			onAdd={this.onDataAdd}
			onDelete={this.onDataDelete}
		/>;
	}
}

class GetVideoInput extends Component {
	render() {
		return <div />;
	}
}

class Sandbox extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedOption: '',
			apiEndpoint: '',
			apiMethod: '',
			apiOverview: '',
			data: null,
			access_token: '',
			createVideoApiResponse: {},
			getVideoApiResponse: {},
			videoId: '',
			loading: false,
			user: null,
			guestUserModalOpen: false,
			getCodeModalOpen: false,
			createVideoSuccessModalOpen: false,
			disabledButton: false
		};
		this.onAPISelect = this.onAPISelect.bind(this);
		this.onDataEdit = this.onDataEdit.bind(this);
		this.onDataAdd = this.onDataAdd.bind(this);
		this.onDataDelete = this.onDataDelete.bind(this);
		this.makeAPICall = this.makeAPICall.bind(this);
		this.callCreateVideoAPI = this.callCreateVideoAPI.bind(this);
		this.callGetVideoAPI = this.callGetVideoAPI.bind(this);
		this.endpointInputChange = this.endpointInputChange.bind(this);
		this.openGetCodeModal = this.openGetCodeModal.bind(this);
		this.closeGetCodeModal = this.closeGetCodeModal.bind(this);
		this.closeGuestUserModal = this.closeGuestUserModal.bind(this);
		this.closeCreateVideoSuccessModal = this.closeCreateVideoSuccessModal.bind(this);
	}

	componentDidMount() {
		axios.get(`${config.url}/api/v2/createvideo/grab/auth?userId=${getUserID()}`)
			.then(response => {
				this.setState({
					access_token: response.data.apiAccessToken
				});
			})
			.catch(err => {
				console.log(err);
			})
	}

	onAPISelect(e, data) {
		if (data.value === 'createVideo') {
			this.setState({
				selectedOption: data.value,
				apiEndpoint: `${config.apiEndpoint}/videos`,
				apiMethod: 'POST',
				apiOverview: 'The create video API lets you programmatically create videos by sending along various data points with your request.',
				data: this.state.data === null ? createVideo : this.state.data
			});
		} else if (data.value === 'getVideo') {
			this.setState({
				selectedOption: data.value,
				apiEndpoint: `${config.apiEndpoint}/videos/{id}`,
				apiMethod: 'GET',
				apiOverview: 'The get video API allows you to retrieve a URL for your video once it is generated'
			});
		}
	}

	onDataEdit(newData) {
		this.setState({
			data: newData
		});
	}

	onDataAdd(newData) {
		this.setState({
			data: newData
		});
	}

	onDataDelete(newData) {
		this.setState({
			data: newData
		});
	}

	makeAPICall() {
		fireCleverTapEvent('Submit Clicked Sandbox', { apiFired : this.state.selectedOption });
		if (!nullCheck(getUserID())) {
			if (this.state.selectedOption === 'createVideo') {
				this.callCreateVideoAPI();
			} else if (this.state.selectedOption === 'getVideo') {
				this.callGetVideoAPI(this.state.videoId);
			}
			this.setState({
				loading: true,
				disabledButton: true
			});
		} else {
			this.setState({
				guestUserModalOpen: true
			});
		}
	}

	callCreateVideoAPI() {
		axios.post(`${config.apiEndpoint}/videos`, this.state.data, { headers: { access_token: this.state.access_token } })
			.then(response => {
				fireCleverTapEvent('Successful Create Video API');
				this.setState({
					createVideoApiResponse: response.data,
					loading: false,
					disabledButton: false,
					createVideoSuccessModalOpen: true
				});
			})
			.catch(err => {
				this.setState({
					createVideoApiResponse: err.response.data,
					loading: false
				});
			});
	}

	callGetVideoAPI(id) {
		axios.get(`${config.apiEndpoint}/videos/${id}`, { headers: { access_token: this.state.access_token } })
			.then(response => {
				if (response.data.message === 'successful' || response.data.message === 'in_progress') {
					this.setState({
						getVideoApiResponse: response.data,
						loading: false,
						disabledButton: false,
					});
				} else if (response.data.message === 'you reached the limit for using this api') {
					this.setState({
						getVideoApiResponse: response.data,
						loading: false,
						disabledButton: false,
						createVideoSuccessModalOpen: true
					});
				} else {
					this.setState({
						disabledButton: false,
					});
				}
			})
			.catch(err => {
				this.setState({
					getVideoApiResponse: err.response.data,
					loading: false,
					disabledButton: false,
				});
			});
	}

	endpointInputChange(e, data) {
		if (this.state.selectedOption === 'getVideo') {
			const value = data.value;
			const newValue = value.replace(`${config.apiEndpoint}/videos/`, '');
			this.setState({
				videoId: newValue
			});
		}
	}

	openGetCodeModal() {

		if (!nullCheck(getUserID())) {
			fireCleverTapEvent('Get Code Clicked Sandbox');
			this.setState({
				getCodeModalOpen: true
			});
		} else {
			this.setState({
				guestUserModalOpen: true
			});
		}
	}

	closeGetCodeModal() {
		this.setState({
			getCodeModalOpen: false
		});
	}

	closeGuestUserModal() {
		this.setState({
			guestUserModalOpen: false
		});
	}

	closeCreateVideoSuccessModal() {
		this.setState({
			createVideoSuccessModalOpen: false
		});
	}

	render() {
		const apiOptions = [
			{
				text: 'Create Video',
				value: 'createVideo'
			},
			{
				text: 'Retrieve Video',
				value: 'getVideo'
			},
			// {
			// 	text: 'Search Media',
			// 	value: 'searchMedia'
			// },
		];

		let sandboxInput = null;
		if (this.state.selectedOption === 'createVideo') {
			sandboxInput = <CreateVideoInput
				data={this.state.data}
				onDataEdit={this.onDataEdit}
				onDataAdd={this.onDataAdd}
				onDataDelete={this.onDataDelete}
			/>;
		} else if (this.state.selectedOption === 'getVideo') {
			sandboxInput = <GetVideoInput/>;
		}

		let apiResponse = {};
		let responseSection = null;

		if (this.state.selectedOption === 'createVideo') {
			apiResponse = this.state.createVideoApiResponse;
		} else if (this.state.selectedOption === 'getVideo') {
			apiResponse = this.state.getVideoApiResponse
		}

		if (this.state.loading) {
			responseSection = <Dimmer active inverted>
				<Loader inverted />
			</Dimmer>;
		} else {
			responseSection = <ReactJson
				src={apiResponse}
				name={false}
				displayDataTypes={false}
				enableClipboard={false}
			/>;
		}

		const submitButtonState = nullCheck(this.state.selectedOption);

		let curlTab = null;
		let pythonTab = null;
		let javascriptTab = null;

		if (this.state.selectedOption === 'createVideo') {
			curlTab = <Tab.Pane>
				<SyntaxHighlighter language='bash' style={okaidia}>
						{`
curl "https://api.rocketium.com/videos"
  -H "access_token: ${this.state.access_token}"
  -H "Content-Type: application/json"
  -d '${JSON.stringify(createVideo)}'
						`}
				</SyntaxHighlighter>
			</Tab.Pane>;

			pythonTab = <Tab.Pane>
				<SyntaxHighlighter language='python' style={okaidia}>
					{`
import urllib.request
import json

body = ${JSON.stringify(createVideo)};

url = "https://api.rocketium.com/videos"
req = urllib.request.Request(url)
req.add_header('access_token', '${this.state.access_token}') # access token
req.add_header('Content-Type', 'application/json; charset=utf-8')
jsondata = json.dumps(body)
jsondataasbytes = jsondata.encode('utf-8')
req.add_header('Content-Length', len(jsondataasbytes))
print (jsondataasbytes)
response = urllib.request.urlopen(req, jsondataasbytes)
					`}
				</SyntaxHighlighter>
			</Tab.Pane>;

			javascriptTab = <Tab.Pane>
				<SyntaxHighlighter language='javascript' style={okaidia}>
					{`
var xmlHttp = new XMLHttpRequest();
var url = "https://api.rocketium.com";
var data = ${JSON.stringify(createVideo)};
xmlHttp.onreadystatechange = function() {
	if (xmlHttp.readyState == 4 && xmlHttp.status == 200)
	callback(xmlHttp.responseText);
}
xmlhttp.setRequestHeader("access_token", "${this.state.access_token}");
xmlHttp.open("POST", url, true); // true for asynchronous
xmlHttp.send(JSON.stringify(data));
					`}
				</SyntaxHighlighter>
			</Tab.Pane>;
		} else if (this.state.selectedOption === 'getVideo') {
			curlTab = <Tab.Pane>
				<SyntaxHighlighter language='bash' style={okaidia}>
					{`
curl "https://api.rocketium.com/videos/<id>"
    -H "access_token: ${this.state.access_token}"
					`}
				</SyntaxHighlighter>
			</Tab.Pane>;

			pythonTab = <Tab.Pane>
				<SyntaxHighlighter language='python' style={okaidia}>
					{`
import urllib2
req = urllib2.Request('https://api.rocketium.com/videos/<id>')
req.add_header('access_token', '${this.state.access_token}')
resp = urllib2.urlopen(req)
content = resp.read()
					`}
				</SyntaxHighlighter>
			</Tab.Pane>;

			javascriptTab = <Tab.Pane>
				<SyntaxHighlighter language='javascript' style={okaidia}>
					{`
var xmlHttp = new XMLHttpRequest();
var url = "https://api.rocketium.com/videos/<id>";
xmlHttp.onreadystatechange = function() {
    if (xmlHttp.readyState == 4 && xmlHttp.status == 200)
        callback(xmlHttp.responseText);
}
xmlhttp.setRequestHeader("access_token", "${this.state.access_token}");
xmlHttp.open("GET", url, true); // true for asynchronous
xmlHttp.send(null);
					`}
				</SyntaxHighlighter>
			</Tab.Pane>;
		}

		const getCodeTabs = [
			{ menuItem: 'cURL', render: () => curlTab },
			{ menuItem: 'Python', render: () => pythonTab },
			{ menuItem: 'Javascript', render: () => javascriptTab },
		];

		let createVideoPopup = <p>Your video will be available in your <a href="/app/workspaces" target='_blank'>Rocketium Dashboard</a> once it is successfully generated using the Create Video API.</p>;
		let getVideoPopup = null;

		if (this.state.createVideoApiResponse.message === 'you reached the limit for using this api') {
			createVideoPopup = <p>You have reached the limit for using this API. <a href="/demo">Talk to us</a> to continue using this API.</p>;
		}

		if (this.state.getVideoApiResponse.message === 'you reached the limit for using this api') {
			getVideoPopup = <p>You have reached the limit for using this API. <a href="/demo">Talk to us</a> to continue using this API.</p>;
		}

		return <Grid className='Sandbox'>
			<Grid.Row className='Sandbox-Header'>
				<Header>Rocketium API Explorer</Header>
				<div>
					<p>
						Use this sandbox to run Rocketium's APIs with custom parameters and find the generated video in your Rocketium account. Check out the <a
						href="/docs/api#quickstart">quick starter guide</a> to get your own API key and generate a custom video. Refer <a
						href="/docs/api">API documentation</a> for more information
					</p>
				</div>
			</Grid.Row>
			<Grid.Row className='Sandbox-Input'>
				<Grid.Column width={8} className='Sandbox-Dropdown'>
					<Dropdown
						button
						options={apiOptions}
						placeholder='Select API'
						className='Sandbox-Dropdown-Button'
						onChange={this.onAPISelect}
					/>
					<Segment className='Sandbox-API-Overview'>{this.state.apiOverview}</Segment>
				</Grid.Column>
				<Grid.Column width={8} className='Sandbox-Endpoint'>
					<Input defaultValue={this.state.apiEndpoint} label={this.state.apiMethod} onChange={this.endpointInputChange} />
					<Button type='submit' onClick={this.makeAPICall} disabled={submitButtonState || this.state.disabledButton}>Submit</Button>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className='Sandbox-Request-Response'>
				<Grid.Column width={8} className='Sandbox-Request'>
					<Segment>
						<div className='Sandbox-Request-Section'>
							{sandboxInput}
						</div>
						<div className='Sandbox-Request-Footer'>
							<Input label='Your API key is' value={this.state.access_token} />
						</div>
					</Segment>
				</Grid.Column>
				<Grid.Column width={8} className='Sandbox-Response'>
					<Segment>
						<div className='Sandbox-Response-Section'>
							{responseSection}
						</div>
						<div className='Sandbox-Response-Footer'>
							<Button disabled={nullCheck(this.state.selectedOption)} onClick={this.openGetCodeModal}>Get Code</Button>
						</div>
					</Segment>
				</Grid.Column>
			</Grid.Row>
			<Modal
				open={this.state.guestUserModalOpen}
				onClose={this.closeGuestUserModal}
				closeIcon={<span className='Sandbox-Modal-Close'><i className='material-icons'>close</i></span>}
			>
				<Modal.Content className='Sandbox-Guest-User-Modal'>
					<p>Please sign up to generate your unique API key. <p>Refer <a href="/docs/api/#quickstart">quick starter guide</a> for detailed steps.</p></p>
				</Modal.Content>
			</Modal>
			<Modal
				open={this.state.getCodeModalOpen}
				onClose={this.closeGetCodeModal}
				closeIcon={<span className='Sandbox-Modal-Close'><i className='material-icons'>close</i></span>}
			>
				<Modal.Content className='Sandbox-Get-Code-Modal'>
					<Tab panes={getCodeTabs} />
				</Modal.Content>
			</Modal>
			<Modal
				open={this.state.createVideoSuccessModalOpen}
				onClose={this.closeCreateVideoSuccessModal}
				closeIcon={<span className='Sandbox-Modal-Close'><i className='material-icons'>close</i></span>}
			>
				<Modal.Content className='Sandbox-Guest-User-Modal'>
					{this.state.selectedOption === 'createVideo' ? createVideoPopup : getVideoPopup}
				</Modal.Content>
			</Modal>
		</Grid>;
	}
}

export default Sandbox;